// extracted by mini-css-extract-plugin
export default {"SearchForm":"SearchForm_SearchForm__0-o+R","Filter":"SearchForm_Filter__e-HXR"};